import {
    AppleIcon,
    BananaIcon,
    CitrusIcon,
    GrapeIcon,
} from 'lucide-react-native';
import { useState } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb, XStack, YStack } from 'tamagui';

import { PillButton } from '../../components/buttons/Button';
import { Icon } from '../../components/icons/Icon';
import { Sheet } from '../../components/sheet/Sheet';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    BodySmallRegular,
} from '../../components/text/Typography';
import {
    InfoButtonWithTooltip,
    TooltipGroupProvider,
    TooltipTrigger,
} from '../../components/tooltip/Tooltip';

export const TOOLTIP_GROUP_1_NAME = 'blender1';
export const TOOLTIP_GROUP_2_NAME = 'blender2';
const TOOLTIP_GROUP_3_NAME = 'blender3';

export const Tooltips = () => {
    const [isSheetOpen, setIsSheetOpen] = useState(false);
    const insets = useSafeAreaInsets();
    const topMargin = isWeb ? 0 : insets.top;

    return (
        <YStack gap={16}>
            <BodySmallRegular>
                To use tooltips, you will need both a TooltipGroupProvider and a
                TooltipTrigger. The TooltipGroupProvider must be defined at the
                *PAGE* level in order to get proper tooltip placement on native.
            </BodySmallRegular>
            <XStack
                gap={16}
                marginHorizontal={30}
                alignItems="center"
                justifyContent="center"
            >
                <InfoButtonWithTooltip
                    tooltipContent="This is an InfoButtonWithTooltip (tooltip group 1)"
                    tooltipGroupName={TOOLTIP_GROUP_1_NAME}
                />
                <TooltipTrigger
                    tooltipContent="This is an apple (tooltip group 1)"
                    tooltipGroupName={TOOLTIP_GROUP_1_NAME}
                >
                    <Icon icon={AppleIcon} color="$marigold1000" size={24} />
                </TooltipTrigger>
                <TooltipTrigger
                    tooltipContent="These are grapes (tooltip group 1)"
                    tooltipGroupName={TOOLTIP_GROUP_1_NAME}
                >
                    <Icon icon={GrapeIcon} color="$marigold1000" size={24} />
                </TooltipTrigger>
                <TooltipTrigger
                    tooltipContent="This is a banana (tooltip group 2)"
                    tooltipGroupName={TOOLTIP_GROUP_2_NAME}
                >
                    <Icon icon={BananaIcon} color="$marigold1000" size={24} />
                </TooltipTrigger>
                <TooltipTrigger
                    tooltipContent="This is a lemon (tooltip group 2)"
                    tooltipGroupName={TOOLTIP_GROUP_2_NAME}
                >
                    <Icon icon={CitrusIcon} color="$marigold1000" size={24} />
                </TooltipTrigger>
                <InfoButtonWithTooltip
                    tooltipContent="This is a 'subtle' InfoButtonWithTooltip (tooltip group 2)"
                    tooltipGroupName={TOOLTIP_GROUP_2_NAME}
                    subtle
                />
            </XStack>
            <BodySmallRegular>
                Pass an array of label/value rows for a two-column tooltip
                (labels left, values right). Strings still render as a single
                block.
            </BodySmallRegular>
            <XStack
                gap={16}
                marginHorizontal={30}
                alignItems="center"
                justifyContent="center"
            >
                <InfoButtonWithTooltip
                    tooltipContent={[
                        { label: 'Account number', value: 'BXFB16K' },
                        { label: 'Ownership', value: 'Solo' },
                        { label: 'Portfolio', value: 'Core' },
                        { label: 'Risk level', value: '10 out of 10' },
                    ]}
                    tooltipGroupName={TOOLTIP_GROUP_1_NAME}
                    subtle
                />
            </XStack>
            <PillButton
                text="See sheet with tooltips"
                onPress={() => {
                    setIsSheetOpen(true);
                }}
            />
            <Sheet
                isOpen={isSheetOpen}
                forceMaxContentHeight={true}
                onClose={() => {
                    setIsSheetOpen(false);
                }}
                showCloseButton={true}
            >
                <YStack marginTop={topMargin} paddingTop={isWeb ? 16 : 0}>
                    <YStack padding={16} gap={16}>
                        <BodyMediumEmphasized>
                            Tooltip positioning should work in all sheet/modal
                            scenarios, cross-platform.
                        </BodyMediumEmphasized>
                        <BodyMediumRegular>Yay!</BodyMediumRegular>
                        <XStack
                            paddingVertical={60}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <InfoButtonWithTooltip
                                tooltipContent="This is an InfoButtonWithTooltip (tooltip group 1)"
                                tooltipGroupName={TOOLTIP_GROUP_3_NAME}
                            />
                            <InfoButtonWithTooltip
                                tooltipContent="This is a 'subtle' InfoButtonWithTooltip (tooltip group 1)"
                                tooltipGroupName={TOOLTIP_GROUP_3_NAME}
                                subtle
                            />
                        </XStack>
                    </YStack>
                </YStack>
                <TooltipGroupProvider tooltipGroupName={TOOLTIP_GROUP_3_NAME} />
            </Sheet>
        </YStack>
    );
};
